import { FaPen } from "react-icons/fa";
import { ImBin } from "react-icons/im";
const SelectedTriggerItem = ({
  item,
  handleEditOption,
  handleDeleteOption,
}) => {
  return (
    <div className="text-md font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed py-2 px-3 bg-zinc-100 bg-opacity-10 min-h-[48px] rounded-md text-p-text cursor-pointer">
      <div className="flex items-center gap-2">
        <div className="flex flex-col flex-1 gap-2">
          <div className="flex flex-col gap-2">
            <div className="flex gap-2 items-center min-h-[30px]">
              <span className="flex-shrink-0">
                <div className="bg-zinc-200 rounded-lg ml-2 p-1">
                  <img alt={item.label} src={item.image} className="h-4 w-4" />
                </div>
              </span>
              <div className="flex-1 min-w-0 pr-6">
                <div className="truncate font-medium text-s-text text-sm">
                  {item.label}
                </div>
              </div>
            </div>
            {item.triggerPhrase && (
              <div class="flex items-center py-1 px-2 border br-1 rounded-[4px] bg-2 text-sm w-fit">
                <span class="font-semibold">Specific Phrase or Keyword</span>: "
                {item.triggerPhrase}"
              </div>
            )}
          </div>
          <ul className="flex flex-wrap gap-2">
            {item?.selectedFunctions?.length > 0 &&
              item?.selectedFunctions?.map((it, idx) => (
                <li
                  key={idx}
                  className="bg-zinc-100 text-zinc-800 px-3 py-1.5 rounded-full text-sm text-s-text"
                >
                  {it.charAt(0).toUpperCase() + it.slice(1).toLowerCase()}
                </li>
              ))}
          </ul>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={handleEditOption}
            className="btn btn-secondary mx-2 text-sm mr-2 text-zinc-200 p-2 rounded-lg hover:bg-zinc-900"
          >
            <FaPen />
          </button>
          <button
            onClick={() => handleDeleteOption(item.id)}
            className="btn btn-danger text-sm text-zinc-200 p-2 rounded-lg hover:bg-zinc-900"
          >
            <ImBin />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectedTriggerItem;
